export default "__VITE_ASSET__uA99KVaY__"